import React from "react";
import { Avatar } from "@mui/material";
import ENV from "../config/env";

// Imagen de perfil del servicio del cliente (la marcada como principal en Clientes), pequeña y cuadrada con bordes suaves.
// Sin imagen se muestra la inicial del cliente para que las filas queden alineadas.
const COLORES = ["#00796b", "#1976d2", "#7b1fa2", "#e65100", "#455a64", "#c2185b", "#388e3c", "#5d4037"];

const colorDe = (texto) => {
  let h = 0;
  for (let i = 0; i < texto.length; i += 1) h = (h * 31 + texto.charCodeAt(i)) % 997;
  return COLORES[h % COLORES.length];
};

export default function ServicioAvatar({ imagen, nombre, size = 26, sx }) {
  const texto = String(nombre || "").trim();
  const src = imagen ? (/^https?:\/\//i.test(imagen) ? imagen : `${ENV.API_BASE_URL}${imagen}`) : undefined;
  return (
    <Avatar
      variant="rounded" src={src} alt={texto} imgProps={{ loading: "lazy" }}
      sx={{ width: size, height: size, flexShrink: 0, fontSize: size * 0.5, fontWeight: 700, bgcolor: src ? "transparent" : colorDe(texto || "?"), ...sx }}
    >
      {texto.charAt(0).toUpperCase() || "?"}
    </Avatar>
  );
}
